module.exports = __webpack_public_path__ + "img/logo.5ee431c1.png";